export default __webpack_public_path__ + "static/media/white-undo-measure-icon.50460d37.svg";